//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/performancecenter/theater";
export default {
  props: ["keyValue", "showDialog"],
  components: {},
  computed: {},
  data: function data() {
    return {
      rules: {
        name: [{
          required: true,
          message: '请输入剧场名称',
          trigger: 'change'
        }],
        maxNum: [{
          required: true,
          message: '请输入容纳人数',
          trigger: 'change'
        }],
        contactName: [{
          required: true,
          message: '请输入联系人',
          trigger: 'change'
        }],
        contactTel: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '请输入11位手机号',
          trigger: 'change'
        }] // row: [
        //   { required: true, message: '请输入横排', trigger: 'change' }
        // ],
        // column: [
        //   { required: true, message: '请输入竖排', trigger: 'change' }
        // ],

      },
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          // if (this.childData.startTime > this.childData.endTime) {
          //   this.Alert({
          //     alertType: "error",
          //     message: "闭馆维修开始日期不能大于闭馆维修结束日期"
          //   });
          //   return;
          // }
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit("handCancle", true);

                _this2.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit("handCancle", true);

                _this2.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};